export default {
  name: "placeholder",
  props: {
    value: [String, Number, Array],
    compact: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      handCursor: false
    }
  },
  computed: {
    setPlaceholderClasses() {
      var isActive = this.compact ? "volcan-placeholder" : ""
      var isDirty =
        this.compact &&
          this.value !== "" &&
          this.value !== null &&
          this.value !== undefined
          ? "volcan-placeholder-dirty"
          : ""
      var cursor = this.handCursor ? "volcan-placeholder-hand" : ""
      return `${isActive} ${isDirty} ${cursor}`
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./mixins/placeholder.js
// module id = viQV
// module chunks = 18